import { AppState } from 'slices/app';
import useSelector from './useSelector';

const useProfileRefererProvider = (): AppState['profileReferer'] =>
  useSelector((state) => state.app.profileReferer);

export default useProfileRefererProvider;
